import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, WeeklyCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  calendar: Identifiable<WeeklyCalendar>;
  retrievePersonalWeeklyCalendar(
    request: Boundaries["retrievePersonalWeeklyCalendar"]["request"],
  ): void;
}

function useRetrievePersonalWeeklyCalendar(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrievePersonalWeeklyCalendarRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrievePersonalWeeklyCalendarRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrievePersonalWeeklyCalendarRequestFailure,
    ),
    calendar: useSelector(selector.getPersonalWeeklyCalendar),
    retrievePersonalWeeklyCalendar: core.retrievePersonalWeeklyCalendar,
  };
}

export { useRetrievePersonalWeeklyCalendar };
